import { SET_SELECTED_REC_DATA } from "../../redux/actions/action.types";

export default function setSelectedRecData(stateHandler: any, payload: any) {
  stateHandler({
    type: SET_SELECTED_REC_DATA,
    payload: payload,
  });
}
